<template>
  <div class="corporation_add">
    <div class="title_header">
      <div class="title_header_value vertical_align_div">
        {{ headerTitle }}
      </div>
    </div>
    <div class="corporation_contents">
      <div class="corporation_contents_background">
        <div class="corporation_edit_area_title">
          {{ contractEditInfoTitle }}
        </div>
        <contractAddInfo></contractAddInfo>
        <div class="corporation_edit_area_title">{{ tenantEditInfoTitle }}</div>
        <tenantAddInfo></tenantAddInfo>
        <div class="corporation_edit_area_title">
          {{ tenantOptionEditInfoTitle }}
        </div>
        <tenantOptionAddInfo></tenantOptionAddInfo>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="corporation_edit_bottom">
        <div class="corporation_edit_bottom_buttons">
          <router-link to="/master/corporations">
            <input type="button" :value="cancelButton" class="cancel_button" />
          </router-link>
          <input
            type="button"
            :value="addButton"
            class="finish_button"
            @click="assignFromAddToDetail"
          />
          <div class="bottom_label">※ 登録後変更不可</div>
        </div>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="modal_window" v-if="showConfirmCorporationModal">
        <confirmCorporationModal @close="stayClose" @ok="createCorporation">
        </confirmCorporationModal>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import contractAddInfo from './corporationComponents/contractAddInfo.vue'
import tenantAddInfo from './corporationComponents/tenantAddInfo.vue'
import tenantOptionAddInfo from './corporationComponents/tenantOptionAddInfo.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import confirmCorporationModal from '../modalWindow/confirmCorporationInfoModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      contractEditInfoTitle: '契約情報',
      tenantEditInfoTitle: 'テナント情報',
      tenantOptionEditInfoTitle: 'テナントオプション',
      cancelButton: 'キャンセル',
      addButton: '追加',
      headerTitle: '追加',
      completeWord: '',
      failureWord: '',
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      showConfirmCorporationModal: false,
      contentsHeight: '',
      contentsBackgroundHeight: ''
    }
  },
  computed: {
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    callAppList() {
      return this.$store.state.corporations.callAppDefine
    }
  },
  async created() {
    this.$store.dispatch('corporations/clearCorporation')
    try {
      await this.$store.dispatch('corporations/setCallAppDefine', null)
    } catch (error) {
      let eventNumber = this.$store.state.error.sysErrorCode.sysErrorCode_140001
      this.createErrorMessage(error, eventNumber, 'MSGCRD0087')
      this.showFailureModal = true
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    tenantAddInfo,
    contractAddInfo,
    tenantOptionAddInfo,
    completeModalWindow,
    loadingModalWindow,
    confirmCorporationModal
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      var contaractHeight = document.getElementById('contract_info')
        .clientHeight
      var tenantHeight = document.getElementById('tenant_info').clientHeight
      var tenantOptionHeight = document.getElementById('tenant_option_info')
        .clientHeight
      var maxHeight = contaractHeight
      if (maxHeight < tenantHeight) {
        maxHeight = tenantHeight
      }
      if (maxHeight < tenantOptionHeight) {
        maxHeight = tenantOptionHeight
      }
      var height = maxHeight
      var contentsPaddingHeight = 52
      var buttonHeight = 40
      this.contentsHeight = height + contentsPaddingHeight + buttonHeight + 'px'
      this.contentsBackgroundHeight = height + 'px'
    },
    close(e) {
      this.showCompleteModal = false
      this.showConfirmCorporationModal = false
      this.$router.push('/master/corporations')
    },
    stayClose(e) {
      this.showCompleteModal = false
      this.showFailureModal = false
      this.showConfirmCorporationModal = false
    },
    async assignFromAddToDetail(e) {
      var locationInfoEnableFlag = document.getElementsByName(
        'location_info_enable'
      )[0].checked

      // var gpsEnableFlag = document.getElementsByName('gps_enable').checked
      var gpsEnableFlag = false

      var mailTargetFlag = document.getElementsByName('mail_target')[0].checked

      var passwordEnableFlag = document.getElementsByName('password_enable')[0]
        .checked

      var autoLogoutEnableFlag = document.getElementsByName(
        'autoLogout_enable'
      )[0].checked

      var ratingQuarityEnableFlag = document.getElementsByName(
        'rationgQuarity_enable'
      )[0].checked

      var pushNotificationEnableFlag = document.getElementsByName(
        'pushNotification_enable'
      )[0].checked

      var spEnableFlag = document.getElementsByName('silentPush_enable')[0]
        .checked

      var contactsEnableFlag = document.getElementsByName('contacts_enable')[0]
        .checked

      var corporationFlags = {
        locationInfoEnableFlag: locationInfoEnableFlag,
        gpsEnableFlag: gpsEnableFlag,
        mailTargetFlag: mailTargetFlag,
        passwordEnableFlag: passwordEnableFlag,
        autoLogoutEnableFlag: autoLogoutEnableFlag,
        ratingQuarityEnableFlag: ratingQuarityEnableFlag,
        pushNotificationEnableFlag: pushNotificationEnableFlag,
        spEnableFlag: spEnableFlag,
        contactsEnableFlag: contactsEnableFlag
      }
      await this.$store.dispatch('corporations/setFlags', corporationFlags)

      var callAppList = []
      for (let i = 0; i < this.callAppList.length; i++) {
        var selector =
          'input[name="' + this.callAppList[i].id + '"].callAppCheckbox'
        if (document.querySelector(selector).checked) {
          callAppList.push({
            id: this.callAppList[i].id,
            callAppName: this.callAppList[i].callAppName,
            urlScheme: this.callAppList[i].urlScheme
          })
        }
      }
      await this.$store.dispatch('corporations/setCallAppList', callAppList)

      await this.$store.dispatch('corporations/assignFromAddToDetail')
      this.showConfirmCorporationModal = true
    },
    async createCorporation(e) {
      this.showloadingModal = true
      this.showConfirmCorporationModal = false
      try {
        await this.$store.dispatch('corporations/addCorporation')
        this.showModal = false
        this.completeWord = '追加しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_140001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0044')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>

<style scoped>
.bottom_label {
  font-size: 14px;
  color: #9b9b9b;
  padding-bottom: 10px;
  padding-top: 10px;
  margin: 0 8px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationAdd.vue